import httpStatus from 'http-status'
import { reativarConta } from '../../../../settings/staticUrl'

const ERROR_REASONS = {
  'Network Error': {
    default: {
      accounts_reason: 'login_timeout',
      error: {
        title: 'Não foi possível acessar sua conta.',
        message: 'Por favor, verifique sua conexão com a internet e tente novamente.',
      },
    },
  },
  [httpStatus.UNAUTHORIZED]: {
    ACCOUNT_NOT_FOUND: {
      accounts_reason: 'account_not_found',
      error: {
        message: 'Não existe uma conta com este e-mail.',
      },
    },
    default: {
      accounts_reason: 'unauthorized',
    },
  },
  [httpStatus.LOCKED]: {
    default: {
      accounts_reason: 'account_locked',
      error: {
        title: 'Por favor, aguarde!',
        message:
          'Estamos atualizando suas informações de contato. Um e-mail será enviado assim que o acesso for liberado.',
      },
    },
  },
  [httpStatus.TOO_MANY_REQUESTS]: {
    default: {
      accounts_reason: 'rate_limit_exceeded',
      error: {
        message: 'Você excedeu o número de tentativas.',
      },
    },
  },
  [httpStatus.GONE]: {
    default: {
      accounts_reason: 'account_inactive',
      error: {
        message: 'Esta conta foi desativada.',
        customLink: { href: reativarConta, text: 'Precisa de ajuda? Reative a sua conta' },
        showContactUs: false,
      },
    },
  },
  [httpStatus.FORBIDDEN]: {
    ACCOUNT_DISABLED: {
      accounts_reason: 'account_disabled',
      error: {
        message: 'Conta temporariamente bloqueada.',
        showContactUs: true,
      },
    },
    ACCOUNT_LOCKED: {
      accounts_reason: 'account_locked',
      error: {
        title: 'Conta bloqueada.',
        showContactUs: true,
      },
    },
    default: {
      accounts_reason: 'turnstile_invalid_token',
      error: {
        message: 'Não foi possível acessar sua conta. Por favor, tente novamente.',
      },
    },
  },
  [httpStatus.BAD_REQUEST]: {
    default: {
      accounts_reason: 'turnstile_missing_token',
      error: {
        message: 'Não foi possível acessar sua conta. Por favor, tente novamente.',
      },
    },
  },
  default: {
    UNEXPECTED_STATUS_CODE: {
      accounts_reason: 'unexpected_status_code',
      error: {
        message: 'Não foi possível acessar sua conta. Por favor, tente novamente.',
      },
    },
    default: {
      accounts_reason: 'unexpected_error',
      error: {
        message: 'Não foi possível acessar sua conta. Por favor, tente novamente.',
      },
    },
  },
}

export const handleEmailValidationExceptions = (error = {}) => {
  const { response: { status, data } = {} } = error

  const statusCode = status ? status : 'UNEXPECTED_STATUS_CODE'

  const errorReason = ERROR_REASONS[statusCode] || ERROR_REASONS.default
  const specificReason = errorReason[data?.message] || errorReason.default

  return {
    errorInfo: specificReason?.error || ERROR_REASONS.default.error,
    lurkerExtraData: {
      accounts_reason: specificReason.accounts_reason,
      accounts_status_code: status,
      accounts_error_message: error?.message || 'unknown',
    },
  }
}
